import { StringBoolean } from "web/types/Utils";

const convertBoolStringToBool = (value?: StringBoolean) => !!(value && +value);

export default convertBoolStringToBool;
